import { useState } from 'react';

const KEY = 'cli-tutorial-progress';

type Progress = {
  lastStepSeen: string | null;
  stepsSeen: string[];
};

function useProgress() {
  const [progress, setProgress] = useState<Progress>(() => {
    return (
      JSON.parse(localStorage.getItem(KEY)) || {
        lastStepSeen: null,
        stepsSeen: [],
      }
    );
  });

  const mutate = (progressNext: Progress) => {
    localStorage.setItem(KEY, JSON.stringify(progressNext));
    setProgress(progressNext);
  };

  return { progress, mutate };
}

export default useProgress;
